import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

const facebookPageUrl = 'https://www.facebook.com/TeamGogoBoys/';
const facebookFeedUrl = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPageUrl)}&tabs=timeline&width=500&height=520&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false`;

export default function FacebookFeed() {
  return <Paper
    component="section"
    aria-labelledby="facebook-feed-heading"
    variant="outlined"
    sx={{ mt:{ xs:5, md:7 }, borderRadius:{ xs:3, md:4 }, borderColor:'#DFE7F0', overflow:'hidden' }}
  >
    <Box sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', md:'minmax(280px, .9fr) minmax(340px, 1.1fr)' }, alignItems:'stretch' }}>
      <Box sx={{ bgcolor:'#07182D', color:'white', p:{ xs:4, md:5 }, display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'flex-start' }}>
        <Box sx={{ width:52, height:52, borderRadius:'50%', bgcolor:'#1877F2', display:'grid', placeItems:'center', mb:3 }}>
          <FacebookRoundedIcon sx={{ fontSize:32 }} />
        </Box>
        <Typography className="section-kicker" component="p" sx={{ color:'secondary.main', mb:1 }}>From the club</Typography>
        <Typography id="facebook-feed-heading" variant="h3" sx={{ fontSize:{ xs:'2rem', md:'2.65rem' } }}>Follow every moment.</Typography>
        <Typography sx={{ color:'rgba(255,255,255,.68)', mt:2, lineHeight:1.75 }}>See match-day updates, team news, community stories, and moments from Gogo Boys Base on our official Facebook page.</Typography>
        <Button
          href={facebookPageUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          color="secondary"
          endIcon={<OpenInNewRoundedIcon />}
          sx={{ mt:3.5 }}
        >
          Follow on Facebook
        </Button>
      </Box>
      <Box sx={{ bgcolor:'#F4F7FB', minHeight:520, p:{ xs:2, sm:3 }, display:'grid', placeItems:'center', overflow:'hidden' }}>
        <Box
          component="iframe"
          title="Darajani Gogo FC Facebook timeline"
          src={facebookFeedUrl}
          loading="lazy"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          sx={{ border:0, width:'100%', maxWidth:500, height:520, display:'block', bgcolor:'white' }}
        />
      </Box>
    </Box>
  </Paper>;
}
